// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"styles_deleteButton__xVVlt","floating":"styles_floating__E69hL","fadeInOut":"styles_fadeInOut__aEiTe","loader":"styles_loader__30fu5"};